import { createSelector } from '@reduxjs/toolkit'
import { get } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = { tags: [], tagsRequested: false, isLoading: false }

export const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.FETCH_CONTENT_TAGS_START:
      return { ...state, isLoading: true, tagsRequested: true }
    case types.FETCH_CONTENT_TAGS_SUCCESS:
      return {
        ...state,
        tags: action.payload,
        isLoading: false,
      }
    case types.FETCH_CONTENT_TAGS_FAILURE: {
      return { ...state, isLoading: false }
    }
    default:
      return state
  }
}

export const selectContentTags = (store) => get(store, 'contentTags.tags', INITIAL_STATE.tags)

export const selectContentTagsByCategory = createSelector(selectContentTags, (tags) => {
  const map = {}
  tags.forEach(({ category, tag }) => {
    if (!Array.isArray(map[category])) {
      map[category] = []
    }
    map[category].push(tag)
  })
  return map
})

export default reducer
